/* eslint-disable react-hooks/exhaustive-deps */
import "./styles.css";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import SeparatorImage from "../../../../shared/components/breadcrumbs/icons/separator.svg";
import CircleIcon from "@mui/icons-material/Circle";
import {
  Box,
  Breadcrumbs,
  Button,
  Chip,
  DialogContent,
  Divider,
  IconButton,
  Link,
  ListItemIcon,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect } from "react";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import { getLocalStorageData } from "../../../../shared/utils/localStorage";
import NoDataFound from "../../../../shared/components/noDataFoundBanner";
import SearchBox from "../../../../shared/components/searchBox";
import HashLoader from "../../../../shared/components/loader/hashLoader";
import { formatTitle } from "../../../../shared/utils/formatter";
import { GCTooltip } from "../../../../shared/components";

export default function AccountChangeModal(props: any) {
  const localStorageData = getLocalStorageData("userData");
  const { account, setAccount } = useContext(SidebarContext);

  useEffect(() => {
    if (props?.data && !account?.selectedKey) {
      setAccount((prevData: any) => {
        let key = "All",
          data = props.data;
        if (localStorageData?.userType === "SuperAdmin") {
          key = props?.data?.[0]?.parent?.name;
          data = props?.data;
        }
        if (key) {
          prevData.accounts[key] = {
            id: props?.data?.[0]?.parent?.accountId,
          };
        }
        return {
          ...prevData,
          selectedKey: key ?? prevData?.selectedKey,
          parent: prevData?.parent ?? key,
          accounts: {
            ...prevData?.accounts,
            list: data,
          },
        };
      });
    }
  }, []);

  const Separator = () => {
    return (
      <img src={SeparatorImage} alt="Separator" className="separatorArrow" />
    );
  };

  const breadcrumbsOnClick = (name: string, index: number) => {
    if (name === account?.selectedKey && index === 1) {
      setAccount((prevData: any) => {
        return {
          ...prevData,
          selectedId: prevData?.accounts?.[prevData?.selectedKey]?.id,
          id: null,
          name: null,
          parent: prevData?.selectedKey,
          campaign: null,
          adGroup: null,
        };
      });
      props?.onClose();
    } else {
      setAccount((prevData: any) => {
        const newAccountsObject: any = {};
        Object?.keys(account?.accounts ?? {})?.map(
          (data: string, dataIndex) => {
            if (dataIndex <= index) {
              newAccountsObject[data] = account?.accounts[data];
            } else {
              newAccountsObject[data] = {
                ...account?.accounts[data],
                inactive: true,
              };
            }
            return null;
          }
        );
        newAccountsObject.list = [];
        return {
          ...prevData,
          selectedKey: name,
          selectedId: prevData?.accounts?.[name]?.id,
          searchTerm: null,
          accounts: newAccountsObject,
        };
      });
    }
  };

  return (
    <Dialog
      open={props?.open}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: 530,
          maxWidth: 530,
          maxHeight: 550,
          minHeight: 500,
        },
      }}
      maxWidth="sm"
    >
      <DialogTitle>
        <Typography color="black" fontWeight="bold">
          {account?.open === "client"
            ? "Select Client Account"
            : "Select Account"}
          <Button
            size="small"
            className="accountCloseButton"
            variant="outlined"
            onClick={() => {
              setAccount((prevData: any) => {
                const newAccountsObject: any = {};
                let found = false;
                Object?.keys(account?.accounts ?? {})?.map((data: string) => {
                  if (!found) {
                    if (data === prevData?.parent) found = true;
                    if (data === "list") {
                      newAccountsObject[data] = account?.accounts[data];
                    } else {
                      newAccountsObject[data] = {
                        ...account?.accounts[data],
                        inactive: false,
                      };
                    }
                  }
                  return null;
                });
                newAccountsObject.list = [];
                return {
                  ...prevData,
                  searchTerm: null,
                  selectedKey: prevData?.parent,
                  selectedId: prevData?.accounts?.[prevData?.parent]?.id,
                  accounts: newAccountsObject,
                };
              });
              props?.onClose();
            }}
          >
            <CloseIcon fontSize="small" />
          </Button>
        </Typography>
        <Breadcrumbs separator={Separator()} className="breadcrumbs">
          {Object?.keys(account?.accounts ?? {})?.map(
            (name, index) =>
              name !== "list" &&
              !account?.accounts?.[name]?.inactive && (
                <Link
                  variant="h3"
                  color={"inherit"}
                  className={
                    name === account?.selectedKey && index !== 1
                      ? "lastItem"
                      : "cursorPointer"
                  }
                  onClick={() =>
                    !(name === account?.selectedKey && index !== 1) &&
                    breadcrumbsOnClick(name, index)
                  }
                  key={name}
                >
                  <Typography variant="h3">{name}</Typography>
                </Link>
              )
          )}
        </Breadcrumbs>
        {account?.open === "client" && (
          <Typography variant="h3" marginTop={2} fontWeight="normal">
            This page isn't available in a manager account. Please select a
            client account to view it.
          </Typography>
        )}
      </DialogTitle>
      <DialogContent dividers className="dialogContentPadding">
        <Box className="accountSwitchLeftDialogBoxContainer">
          <Box className="accountSelected">
            <SearchBox
              handleSearch={(value: any) => {
                setAccount((prevData: any) => {
                  return {
                    ...prevData,
                    searchTerm: value,
                  };
                });
              }}
              value={account?.searchTerm}
            />
          </Box>
          <Divider />
          <Box className="accountLeftDialogBox">
            {props?.loading ? (
              <HashLoader />
            ) : (
              <List className="changeAccountList">
                {account?.accounts?.["list"]?.length > 0 ? (
                  account?.accounts?.["list"]?.map(
                    (dataItem: any, index: number) => (
                      <ListItem
                        key={index}
                        className="changeAccountList"
                        secondaryAction={
                          <>
                            {dataItem?.customerType === "Manager" && (
                              <GCTooltip
                                title="View Child accounts"
                                arrow
                                placement="right"
                              >
                                <IconButton
                                  onClick={(e: any) => {
                                    e.stopPropagation();
                                    setAccount((prevData: any) => {
                                      return {
                                        ...prevData,
                                        selectedKey: dataItem?.name,
                                        selectedId: dataItem?.accountId,
                                        searchTerm: null,
                                        accounts: {
                                          ...prevData?.accounts,
                                          [dataItem?.name]: {
                                            id: dataItem?.accountId,
                                          },
                                        },
                                      };
                                    });
                                  }}
                                >
                                  <KeyboardArrowRightIcon />
                                </IconButton>
                              </GCTooltip>
                            )}
                          </>
                        }
                      >
                        <ListItemButton
                          key={index}
                          className={`${
                            (account?.open === "client" &&
                              dataItem?.customerType === "Client") ||
                            account?.open !== "client"
                              ? "listItemButton"
                              : "disabledListItemButton"
                          } ${
                            account?.id === dataItem?.accountId
                              ? "selectedListItem"
                              : ""
                          }`}
                          onClick={() => {
                            if (
                              (account?.open === "client" &&
                                dataItem?.customerType === "Client") ||
                              account?.open !== "client"
                            ) {
                              setAccount((prevData: any) => {
                                return {
                                  ...prevData,
                                  name: dataItem?.name,
                                  id: dataItem?.accountId,
                                  manager:
                                    dataItem?.customerType === "Manager"
                                      ? true
                                      : false,
                                  parent: account?.selectedKey,
                                  searchTerm: null,
                                  campaign: null,
                                  adGroup: null,
                                };
                              });
                              props?.onClose();
                            }
                          }}
                        >
                          <ListItemIcon>
                            <GCTooltip
                              title={formatTitle(dataItem?.customerStatus)}
                              arrow
                              placement="left"
                            >
                              <CircleIcon
                                fontSize="small"
                                className={`${dataItem?.customerStatus}AccountStatus`}
                              />
                            </GCTooltip>
                          </ListItemIcon>
                          <ListItemText
                            primary={`${dataItem?.name}`}
                            secondary={dataItem?.accountId
                              ?.toString()
                              ?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}
                          />
                          <ListItemIcon>
                            <Chip
                              label={dataItem?.customerType}
                              color={
                                dataItem?.customerType === "Client"
                                  ? "warning"
                                  : "success"
                              }
                              variant="outlined"
                              className={"statusChip"}
                            />
                          </ListItemIcon>
                        </ListItemButton>
                      </ListItem>
                    )
                  )
                ) : (
                  <NoDataFound className="changeAccountNoData" />
                )}
              </List>
            )}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
